module.exports = __webpack_public_path__ + "media/images/icons/flags/ZW-f44c662d2a1da0e4686f1ac1ee03d51b.svg";